import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue')
  },
  {
    path: '/brand-case',
    name: 'BrandCase',
    component: () => import('../views/BrandCase.vue')
  },
  {
    path: '/brand-case-detail/:id',
    name: 'BrandCaseDetail',
    component: () => import('../views/BrandCaseDetail.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue')
  },
  {
    path: '/brand-upgrade',
    name: 'BrandUpgrade',
    component: () => import('../views/BrandUpgrade.vue')
  },
  {
    path: '/think-tank',
    name: 'ThinkTank',
    component: () => import('../views/ThinkTank.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/case-detail/:id',
    name: 'CaseDetail',
    component: () => import('../views/CaseDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（比如浏览器后退），则返回保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到页面顶部
      return { x: 0, y: 0 }
    }
  }
})

export default router
